<template>
  <transition>
    <div class="newsList DivImage" :style="{background: 'url('+ backgroungImg +') no-repeat'}">
      <img src="../../assets/image/logo-light.png" alt="logo" class="logo-dark">
      <info-header :type="'5'"></info-header>
      
      <div class="news-container">
        <div class="news-content">
          <div class="news-header">
            <h2>LATEST NEWS</h2>
            <!-- <div class="line"></div> -->
          </div>

          <div class="news-items">
            <div class="news-item" v-for="(item, index) in newsList" :key="index" @click="goToDetail(item.newsId)">
              <div class="news-cover" :style="{background: 'url('+ item.coverUrl +') no-repeat', 'background-size': 'cover'}">
                <!-- <img :src="item.coverUrl" alt="cover"> -->
              </div>
              <div class="news-info">
                <h3 class="news-title">{{ item.title }}</h3>
                <p class="news-time">{{ item.createAt }}</p>
                <!-- <p class="news-desc">{{ extractText(item.content, 60) }}</p> -->
              </div>
            </div>
            
            <!-- 空数据提示 -->
            <div class="empty-data" v-if="newsList.length === 0">
              <p>暂无数据</p>
            </div>
          </div>

          <div class="pagination-wrapper" v-show="newsList.length > 10">
            <Page size="small" :total="totalCount" :current="pageNo" show-elevator show-total class-name="custom-pagination"/>
          </div>
        </div>
      </div>

      <info-footer :isStatic="true"></info-footer>
    </div>
  </transition>
</template>

<script>
  import InfoHeader from '../../components/infoHeader.vue'
  import InfoFooter from '../../components/infoFooter.vue'

  export default {
    name: 'NewsList',
    components: {
      InfoHeader, InfoFooter
    },
    // meta
    metaInfo: {
      title: 'FTG Studio - News List',
      meta: [
        { name: 'description', content: 'View our latest studio updates, newly completed architectural visualization projects, industry trend insights and professional case sharing. This section also features our official industry accolades and recognitions, including being featured in Architizer Visionary 100 and receiving honors of the Architizer Vision Award, alongside project milestones, team highlights and practical knowledge articles about architectural rendering and CGI production.' }
      ]
    },
    data() {
      return {
        backgroungImg: 'https://cdn.ftgstudio.com/ftg-server/ndata/image/20191019/img-TCPzBEVsiF.jpg',
        newsList: [],
        totalCount: 0,
        pageNo: 1,
        pageSize: 10
      }
    },
    methods: {
      goToDetail(id) {
        this.$router.push({ path: `/news/detail`, query: { id } });
      },
      getNewsList() {
        this.$api.getNewsList({}).then(res => {
          if(res.rescode == 0){
            this.newsList = res.list.map(item => ({
              ...item,
              coverUrl: item.coverUrl.replace('www.ftgstudio.com', 'cdn.ftgstudio.com'),
            }))
            this.totalCount = res.size;
          }
        })
      },
      // 从 HTML 中提取纯文本，并限制字数
      extractText(html, maxLength = 35) {
        if (!html) return '';
        
        // 创建临时 div 元素来解析 HTML
        const div = document.createElement('div');
        div.innerHTML = html;
        
        // 获取纯文本内容
        let text = div.textContent || div.innerText || '';
        
        // 去除多余空格和换行
        text = text.replace(/\s+/g, ' ').trim();
        
        // 如果超过最大长度，截取并添加省略号
        if (text.length > maxLength) {
          return text.substring(0, maxLength) + '...';
        }
        
        return text;
      }
    },
    mounted() {
      this.getNewsList();
    }
  }
</script>

<style scoped lang="less">
  @import '../../assets/css/main.less';

  .newsList {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    background-size: cover !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .news-container {
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 50px 20px;
    // background: rgba(0, 0, 0, 0.4); /* Dark overlay for readability */
  }

  .news-content {
    width: 100%;
    max-width: 1000px;
    // background: rgba(255, 255, 255, 0.9);
    background: transparent;
    backdrop-filter: blur(3px);
    border-radius: 4px;
    padding: 40px;
    // box-shadow: 0 10px 30px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
  }

  .news-header {
    text-align: center;
    margin-bottom: 40px;

    h2 {
      font-size: 32px;
      font-weight: 300;
      letter-spacing: 4px;
      color: #FFF;
      margin-bottom: 15px;
    }

    .line {
      width: 60px;
      height: 2px;
      background-color: #d35d1e;
      margin: 0 auto;
    }
  }

  .news-items {
    flex: 1;
  }

  .news-item {
    display: flex;
    margin-bottom: 30px;
    padding-bottom: 30px;
    // border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: all 0.3s ease;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }

    &:hover {
      transform: translateY(-2px);
    }
  }

  .news-cover {
    width: 180px;
    height: 120px;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 4px;
    margin-right: 30px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }
  }

  .news-item:hover .news-cover img {
    transform: scale(1.05);
  }

  .news-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px 0;
  }

  .news-title {
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
    margin-bottom: 0px;
    padding-top: 5px;
    line-height: 1.4;
    transition: color 0.3s;
  }

  .news-time {
    font-size: 18px;
    color: #999;
    margin-bottom: 20px;
    font-family: 'Arial', sans-serif;
    color: #FFF !important;
  }

  .news-desc {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #FFF !important;
  }

  .pagination-wrapper {
    margin-top: 50px;
    text-align: center;
  }

  .empty-data {
    text-align: center;
    padding: 80px 20px;
    
    p {
      font-size: 16px;
      color: #FFF;
      margin: 0;
      letter-spacing: 2px;
    }
  }

  /* Responsive Design */
  @media screen and (max-width: 768px) {
    .news-content {
      padding: 20px;
    }

    .news-item {
      flex-direction: column;
    }

    .news-cover {
      width: 100%;
      height: 200px;
      margin-right: 0;
      margin-bottom: 15px;
    }

    .news-title {
      font-size: 18px;
    }
  }
</style>

<style>
  .ivu-page-options,
  .ivu-page-total {
    display: none !important;
  }
</style>




// WEBPACK FOOTER //
// src/pages/news/list.vue